import React from 'react';
import Tabla from '../utils/Tabla';


const UsuariosLayer = () => {

    return (
        <>
             <Tabla />
        </>
    );
};

export default UsuariosLayer;